import React from "react";
import { checkTimestampStatus, getByPath, getConfigByPath, validity } from "../../features/Sensors/SensorUtils";
import { useAppSelector } from "../../hooks";

type Field = {
  label: string;
  path?: string;
  render?: () => React.ReactNode;
};

type DataBlockProps = {
  DataFields: Field[];
  children?: React.ReactNode;
};

export default function NavData({ DataFields, children }: DataBlockProps): JSX.Element {
  const measurements = useAppSelector((state) => state.Measurements.measurements);
  const config = useAppSelector((state) => state.Config.shipsconfig);

  return (
    <div className="transition-all">
      <table className="max-w-full w-full">
        {DataFields.map((field, index) => {
          if (!config) return null;

          let rowValidity: validity | null = null;
          if (field.path) {
            rowValidity = checkTimestampStatus(
              getByPath(field.path, measurements)?.timestamp,
              getConfigByPath(field.path, config)?.frequency
            );
          }

          const valueNode = field.render
            ? field.render()
            : field.path
              ? getByPath(field.path, measurements)?.value
              : null;

          return (
            <tr className="th-readability even:text-black dark:even:bg-ngray" key={index}>
              <td className="w-1/2 px-2 pr-10 font-bold">{field.label}</td>

              <td className={"flex justify-between px-2 w-1/2 " + (rowValidity?.color ?? "")}>
                <div>{valueNode}</div>
                <div>{rowValidity?.icon ?? null}</div>
              </td>
            </tr>
          );
        })}

        {children}
      </table>
    </div>
  );
}